(() => {
  'use strict';

  const updateStickyOffset = () => {
    const announcement = document.querySelector('.f-announcement');
    document.documentElement.style.setProperty('--f-announcement', `${announcement ? announcement.offsetHeight : 0}px`);
  };

  const fullRes = (src = '') => src.replace('_800x800.', '.');

  const liveReleases = {
    '/pages/one-live-in-los-angeles': {
      title: 'One (Live in Los Angeles)',
      listen: 'https://seanflood.floodeverything.com/one-live-in-los-angeles-listen',
      youtubeId: 'AL62L7N27LM',
      cover: 'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/19_fbac7e15-3190-433d-9468-0e8e7240bddf.png?v=1787425111',
      frames: [
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/9.png?v=1787361556',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/6.png?v=1787361556',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/1_9c58c494-9a9b-4d38-bd4f-1ec4f2382f3d.png?v=1787361556',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/15_2246fd01-711b-417c-9527-ba91535816ef.png?v=1787361575',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/17.png?v=1787361575',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/16_e2875f18-babf-4124-b6a8-a99025b7eae8.png?v=1787361575'
      ],
      credits: [
        'Created by Sean Flood',
        'Written, performed, produced, recorded, mixed, mastered, edited & directed by Sean Flood · Director of Photography: Enzo Laclotte'
      ],
      prevHref: '/pages/one',
      prevLabel: 'One'
    },
    '/pages/gone-live-in-los-angeles': {
      title: 'Gone (Live in Los Angeles)',
      listen: 'https://seanflood.floodeverything.com/gone-live-in-los-angeles-listen',
      youtubeId: 'IxOPd6mpEV4',
      cover: 'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/19_fbac7e15-3190-433d-9468-0e8e7240bddf.png?v=1787425111',
      frames: [
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.18.png?v=1787435645',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.16.png?v=1787435645',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.12.png?v=1787435645',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.13.png?v=1787435645',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.5.png?v=1787435644',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.9.png?v=1787435644'
      ],
      credits: [
        'Created by Sean Flood',
        'Written, performed, produced, recorded, mixed, mastered, edited & directed by Sean Flood · Director of Photography: Enzo Laclotte'
      ],
      prevHref: '/pages/gone',
      prevLabel: 'Gone'
    },
    '/pages/dreaming-live-in-los-angeles': {
      title: 'Dreaming (Live In Los Angeles)',
      listen: 'https://seanflood.floodeverything.com/dreaming-live-in-los-angeles-listen',
      youtubeId: 'QVWaPePPe5o',
      cover: 'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/19_fbac7e15-3190-433d-9468-0e8e7240bddf.png?v=1787425111',
      frames: [
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/2.png?v=1787437579',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/YT_TB.png?v=1787437381',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/21.png?v=1787437381',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/14.png?v=1787437381',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/11_905a2a43-b114-4bd7-a898-3abd9f580a84.png?v=1787437381',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/16_ddf79fac-9af0-4ba7-8866-d9f741c9d2fe.png?v=1787437386'
      ],
      credits: [
        'Created by Sean Flood',
        'Written, performed, produced, recorded, mixed, mastered, edited & directed by Sean Flood · Director of Photography: Enzo Laclotte'
      ],
      prevHref: '/pages/dreaming',
      prevLabel: 'Dreaming'
    },
    '/pages/sleeping-in-wires-live-in-los-angeles': {
      title: 'Sleeping In Wires (Live In Los Angeles)',
      listen: 'https://seanflood.floodeverything.com/sleeping-in-wires-live-in-los-angeles-listen',
      youtubeId: 'UCNK6CgTQVU',
      cover: 'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/Still_2025-09-16_114734_1.2.18_498aa3d3-be2f-4286-b141-63ba85ac2f01.png?v=1787439309',
      frames: [
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/2.png?v=1787437579',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/12_9e8edc70-bf2f-4ae5-92ed-21fab8d76f89.png?v=1787437579',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/14_ea300c11-9dcc-4618-9e84-114713d8efbb.png?v=1787437579',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/17_66344001-caea-4ce5-ae8f-d1ec38b4f159.png?v=1787437579',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/4.png?v=1787437580',
        'https://cdn.shopify.com/s/files/1/0750/7676/3682/files/13.png?v=1787437585'
      ],
      prevHref: '/pages/sleeping-in-wires',
      prevLabel: 'Sleeping In Wires'
    }
  };

  const hydrateLiveRelease = (root = document) => {
    const path = window.location.pathname.replace(/\/$/, '');
    const data = liveReleases[path];
    if (!data) return;

    const page = root.querySelector?.('.f-release-page') || document.querySelector('.f-release-page');
    if (!page || page.dataset.liveReleaseHydrated === path) return;
    page.dataset.liveReleaseHydrated = path;

    const hero = page.querySelector('.f-release-hero');
    const oldCover = hero?.querySelector('.f-release-cover');
    if (oldCover) {
      const cover = document.createElement('a');
      cover.className = 'f-release-cover';
      cover.href = '#watch-film';
      cover.setAttribute('aria-label', `Watch ${data.title} film`);
      cover.innerHTML = `<img src="${data.cover}" alt="${data.title} cover art" loading="eager">`;
      oldCover.replaceWith(cover);
    }

    const actions = page.querySelector('.f-release-actions');
    const listen = actions?.querySelector('.f-release-button--filled');
    if (listen) {
      if (data.listen) listen.href = data.listen;
      else listen.remove();
    }
    if (actions && !actions.querySelector('a[href="#watch-film"]')) {
      const watch = document.createElement('a');
      watch.className = 'f-release-button';
      watch.href = '#watch-film';
      watch.textContent = 'Watch Film';
      const back = actions.querySelector('a[href="/pages/flood-sound"]');
      if (back) actions.insertBefore(watch, back);
      else actions.appendChild(watch);
    }

    const navSection = page.querySelector('.f-release-nav')?.closest('.f-release-section');
    if (!navSection) return;

    const watchSection = document.createElement('div');
    watchSection.className = 'f-release-section';
    watchSection.id = 'watch-film';
    watchSection.innerHTML = `<h2 class="f-release-section-title">Watch Film</h2><div class="f-release-video"><iframe src="https://www.youtube.com/embed/${data.youtubeId}?rel=0&modestbranding=1" title="${data.title} by Sean Flood" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>`;

    const framesSection = document.createElement('div');
    framesSection.className = 'f-release-section';
    framesSection.innerHTML = `<h2 class="f-release-section-title">Selected Frames</h2><div class="f-release-frames">${data.frames.map((src, i) => `<button type="button" class="f-release-frame" data-release-lightbox-trigger data-index="${i}" aria-label="Expand ${data.title} selected frame ${i + 1}"><img src="${src}" alt="${data.title} selected frame ${i + 1}" loading="lazy"></button>`).join('')}</div><div class="f-release-lightbox" data-release-lightbox hidden role="dialog" aria-modal="true" aria-label="${data.title} selected frame viewer"><button type="button" class="f-release-lightbox__control f-release-lightbox__close" data-release-lightbox-close aria-label="Close image viewer">Close</button><button type="button" class="f-release-lightbox__control f-release-lightbox__arrow" data-release-lightbox-prev aria-label="Previous frame">←</button><div class="f-release-lightbox__stage" data-release-lightbox-stage><img class="f-release-lightbox__image" data-release-lightbox-image src="" alt=""></div><button type="button" class="f-release-lightbox__control f-release-lightbox__arrow" data-release-lightbox-next aria-label="Next frame">→</button></div>`;

    const inserts = [watchSection, framesSection];
    if (data.credits?.length) {
      const creditsSection = document.createElement('div');
      creditsSection.className = 'f-release-section';
      creditsSection.innerHTML = `<h2 class="f-release-section-title">Credits</h2><div class="f-release-credits">${data.credits.map((credit) => `<p>${credit}</p>`).join('')}</div>`;
      inserts.push(creditsSection);
    }
    navSection.before(...inserts);

    const navLeft = navSection.querySelector('.f-release-nav > div:first-child');
    if (navLeft && data.prevHref) navLeft.innerHTML = `<a href="${data.prevHref}">← ${data.prevLabel || 'Previous'}</a>`;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    page.querySelectorAll('a[href="#watch-film"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        watchSection.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#watch-film');
      });
    });
  };

  const fixReleaseLinks = (root = document) => {
    const path = window.location.pathname.replace(/\/$/, '');
    if (path === '/pages/favorite') {
      const listenLink = root.querySelector?.('.f-release-button--filled') || document.querySelector('.f-release-button--filled');
      if (listenLink) listenLink.href = 'https://seanflood.floodeverything.com/favorite-listen';
    }
  };

  const initReleaseLightbox = (root = document) => {
    const section = root.matches?.('.shopify-section') ? root : root.querySelector?.('[data-release-lightbox]')?.closest('.shopify-section');
    const scope = section || root;
    const originalLightbox = scope.querySelector?.('[data-release-lightbox]');
    const originalTriggers = Array.from(scope.querySelectorAll?.('[data-release-lightbox-trigger]') || []);
    if (!originalLightbox || !originalTriggers.length || originalLightbox.dataset.uniformInitialized) return;

    const lightbox = originalLightbox.cloneNode(true);
    lightbox.dataset.uniformInitialized = 'true';
    originalLightbox.replaceWith(lightbox);

    const triggers = originalTriggers.map((trigger) => {
      const clone = trigger.cloneNode(true);
      trigger.replaceWith(clone);
      return clone;
    });

    const image = lightbox.querySelector('[data-release-lightbox-image]');
    const stage = lightbox.querySelector('[data-release-lightbox-stage]');
    const closeButton = lightbox.querySelector('[data-release-lightbox-close]');
    const prevButton = lightbox.querySelector('[data-release-lightbox-prev]');
    const nextButton = lightbox.querySelector('[data-release-lightbox-next]');
    if (!image || !stage || !closeButton || !prevButton || !nextButton) return;

    const frames = triggers.map((trigger) => {
      const img = trigger.querySelector('img');
      return { src: fullRes(img?.getAttribute('src') || img?.currentSrc || img?.src || ''), alt: img?.alt || '' };
    });

    let activeIndex = 0;
    let previousFocus = null;
    let touchStartX = null;
    const render = () => { const frame = frames[activeIndex]; image.src = frame.src; image.alt = frame.alt; };
    const open = (index) => { activeIndex = index; previousFocus = document.activeElement; render(); lightbox.hidden = false; document.body.style.overflow = 'hidden'; closeButton.focus(); };
    const close = () => { lightbox.hidden = true; image.src = ''; document.body.style.overflow = ''; if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus(); };
    const move = (direction) => { activeIndex = (activeIndex + direction + frames.length) % frames.length; render(); };

    triggers.forEach((trigger, index) => trigger.addEventListener('click', () => open(index)));
    closeButton.addEventListener('click', close);
    prevButton.addEventListener('click', () => move(-1));
    nextButton.addEventListener('click', () => move(1));
    lightbox.addEventListener('click', (event) => { if (event.target === lightbox || event.target === stage) close(); });
    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });
    stage.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const delta = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) > 45) move(delta > 0 ? -1 : 1);
      touchStartX = null;
    }, { passive: true });
  };

  const boot = (root = document) => {
    updateStickyOffset();
    hydrateLiveRelease(root);
    fixReleaseLinks(root);
    if (root.querySelectorAll) {
      const lightboxes = root.matches?.('[data-release-lightbox]') ? [root] : Array.from(root.querySelectorAll('[data-release-lightbox]'));
      lightboxes.forEach((box) => initReleaseLightbox(box.closest('.shopify-section') || document));
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);

  window.addEventListener('resize', updateStickyOffset, { passive: true });
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();